'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogAdRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogAdRemote = exports.CatalogAdRemote = {
    fetchCatalogAd: function fetchCatalogAd(_ref) {
        var authToken = _ref.authToken,
            categoryIds = _ref.categoryIds,
            deployment = _ref.deployment,
            keywords = _ref.keywords,
            pageName = _ref.pageName;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/ads/page', deployment);
            request.send({ categoryIds: categoryIds, keywords: keywords, pageName: pageName });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/catalogAd.js
// module id = 6QU5
// module chunks = 57